import { FC, lazy, Suspense } from "react";
import type { Props } from "./TimeTrackEditorDialog";
import { HeaderLoader } from "../../../components/HeaderLoading";

const TimeTrackEditorDialog = lazy(
  () =>
    import(
      /* webpackChunkName: "TimeTrackEditorDialog" */ "./TimeTrackEditorDialog"
    ),
);

export const LazyTimeTrackEditorDialog: FC<Props> = function (props) {
  return (
    <Suspense fallback={<HeaderLoader />}>
      <TimeTrackEditorDialog {...props} />
    </Suspense>
  );
};
